import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonButton, IonHeader, IonText, IonGrid, useIonAlert, useIonLoading } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";

import './LoginPhoneVerify.css';
import AppHeader from "../../../components/AppHeader/AppHeader";
import KeyPad from "../../../components/KeyPad/KeyPad";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../services/redux/hook";
import { Sep30AvailableAuthMethods, Sep30ExternalAuthParams, Sep30RecoveryServer, Sep30VerifyPhoneParams } from "../../../types/stellarseps";
import { recoveryServerApi, useVerifyTokenMutation } from "../../../services/api/recovery-servers/recovery.servers";
import { setWalletInfo } from "../../../services/redux/slices/walletInfo/wallet";
import { WalletKeyRecoveryParameters, WalletRecoveryPhoneRequestParameters, WalletRecoveryPhoneVerifyRequestParameters } from "../../../types/types";
import { ebioroApi, useRecoverWalletByPhoneVerifyMutation } from "../../../services/api/ebioro/ebioro";
import { setUser } from "../../../services/redux/slices/user/user";
import * as Sentry from '@sentry/react'
import { saveEncryptedKeys } from "../../../services/stellar/wallet-sdk/helpers/getKeyMetadata";
import { parsePhoneNumber } from 'awesome-phonenumber';

const LoginPhoneVerifyPage: React.FC<any> = () => {

    const history = useHistory();

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const user = useAppSelector((state) => state.user);
    const [phoneVerifyTokenId, setPhoneVerifyTokenId] = useState<string>();
    const [jwtToken, setJwToken] = useState<string>();
    const [pins, setPins] = useState(Array<string>(6).fill(''));
    const [counter, setCounter] = React.useState(30);
    const [present] = useIonAlert();
    const [verifyTokenTrigger] = useRecoverWalletByPhoneVerifyMutation();

    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        setPins(Array<string>(6).fill(''))
                        return
                    }
                }
            ],

        })

    }

    const [presentLoader, dismissLoader] = useIonLoading();

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);


    const {
        handleSubmit,
        control,
        setValue,
        register,
        getValues,
        formState: { errors }
    } = useForm({ defaultValues: { verifyCode: '' } });

    const resendOTP = async () => {

        setPins(Array<string>(6).fill(''))
        setCounter(30);

        const params: WalletRecoveryPhoneRequestParameters = {
            mobile: user.mobile_number
        }

        // const location: any = history.location;
        // const ebioroRecoveryServer: Sep30RecoveryServer = location.state.detail.recoveryServer;

        // const params: Sep30ExternalAuthParams = {

        //     auth_url: ebioroRecoveryServer.external_url,
        //     method: Sep30AvailableAuthMethods.phone_number,
        //     value: user.mobile_number

        // }

        try {

            // const tokenResponse = await dispatch(recoveryServerApi.endpoints.getPhoneToken.initiate(params, { forceRefetch: true })).unwrap();

            const response = await dispatch(ebioroApi.endpoints.recoverWalletByPhone.initiate(params)).unwrap();
            setPhoneVerifyTokenId(response.message);
            setJwToken(response.auth_token);

        } catch (error) {

            presentErrorAlert({ data: t('application.uncaught.ERROR') })

        }

    }

    const onSubmit = async () => {

        presentLoader();
        const inputCombination = pins.map((i) => String(i)).join('')

        const verifyCode = inputCombination;

        const params: WalletRecoveryPhoneVerifyRequestParameters = {

            tokenId: phoneVerifyTokenId as string,
            code: verifyCode,
            mobile: user.mobile_number,
            auth_token: jwtToken as string
        }

        try {

            const response = await verifyTokenTrigger(params).unwrap();

            if (response.message==='verified'){

                const updatedUser = { ...user }

                updatedUser.is_mobile_number_verified = true;

                //now that the phone is verified.Set the user country code

                const pn = parsePhoneNumber(updatedUser.mobile_number);
                const regionCode = pn.regionCode
                updatedUser.country_code2 = regionCode;

                dispatch(setUser(updatedUser));

                const params:WalletKeyRecoveryParameters = {
                    auth_token:response.auth_token

                }

                const encryptedKeysResponse = await dispatch(ebioroApi.endpoints.getWalletEncryptedKeys.initiate(params)).unwrap();

                if (encryptedKeysResponse){
                    await saveEncryptedKeys(encryptedKeysResponse)
                }

                dismissLoader();
                history.push('/pin/lock')

            }

            else {
                dismissLoader();
                presentErrorAlert({ data: t('registration.phone.verification.VERIFY_ERROR') })
                return;
            }

        } catch (error) {
            dismissLoader();
            Sentry.captureException(error)
            presentErrorAlert({ data: t('registration.phone.verification.VERIFY_ERROR') })
            return;

        }

        // const inputCombination = pins.map((i) => String(i)).join('')

        // const verifyCode = inputCombination;

        // const location: any = history.location;
        // const ebioroRecoveryServer: Sep30RecoveryServer = location.state.detail.recoveryServer;

        // const verifyTokenParams: Sep30VerifyPhoneParams = {
        //     id: phoneVerifyTokenId as string,
        //     token: verifyCode,
        //     base_url: ebioroRecoveryServer.external_url,
        //     auth_token: jwtToken as string


        // }

        // try {

        //     const updatedWalletInfo = { ...walletInfo };

        //     const response = await verifyTokenTrigger(verifyTokenParams).unwrap();

        //     updatedWalletInfo.account_key = response.account; // we got here the account to recover from the recovery server
        //     dispatch(setWalletInfo(updatedWalletInfo));

        //     history.push({
        //         pathname: '/recover/orunpay/warning',
        //         state: {
        //             detail: {
        //                 recoverServer1: {
        //                     serverInfo: ebioroRecoveryServer,
        //                     sep30Jwt: response.token
        //                 }
        //             }
        //         }
        //     })


        // } catch (error) {

        //     presentErrorAlert({ data: t('registration.phone.verification.VERIFY_ERROR') })
        //     return;

        // }

    }

    const handleClick = (value: any) => {
        let tempCode = pins;
        for (var i = 0; i < tempCode.length; i++) {
            if (tempCode[i] == '') {
                tempCode[i] = value
                break;
            }
            else {
                continue
            }
        }
        setPins([...tempCode])
    }

    const handleRemove = () => {
        let tempCode = pins;
        for (let i = tempCode.length - 1; i >= 0; i--) {
            if (tempCode[i] != '') {
                tempCode[i] = '';
                break
            }
            else {
                continue
            }
        }
        setPins([...tempCode])
    }

    const handleChange = (element: any, index: number) => {
        if (isNaN(element.value)) return false;

        setPins([...pins.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    useEffect(() => {

        const location: any = history.location;

        setPhoneVerifyTokenId(location.state.detail.id);
        setJwToken(location.state.detail.jwtToken);

    }, [])


    useEffect(() => {
        let count = 0
        for (let i = 0; i < pins.length; i++) {
            if (pins[i] != '') {
                count += 1
            }
        }
        if (count === 6) {
            onSubmit()
        }
    }, [pins])

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 18 }}>
            <IonPage>
                <IonHeader className="ion-no-border">


                    <AppHeader
                        title={t('registration.phone.verification.HEADER') as string}
                        goBack={true}
                    >
                    </AppHeader>


                </IonHeader>

                <IonContent scrollY={false}>


                    <div className="ion-text-center otp_inputs">
                        <div className="otp-boxes-container">
                            {pins.map((value, index) => (
                                <div
                                    key={index}
                                    className={`otp-box ${value !== '' ? 'otp-box-filled' : ''}`}
                                >
                                    <span className="otp-text">
                                        {value || ''}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <IonText color="medium" className="ion-text-center">
                        <p className="phonePageInfoText ion-text-wrap" >{t('registration.phone.verification.SUBHEADER')} {user.mobile_number} </p>
                    </IonText>


                    <div className="ion-text-center">

                        {counter != 0
                            ? <IonButton
                                disabled={true}
                                onClick={() => resendOTP()}
                                color="primary"
                                fill="clear"
                            >
                                {t('registration.phone.verification.BTN_RESEND_CODE')}
                            </IonButton>
                            :
                            <IonButton
                                disabled={false}
                                onClick={() => resendOTP()}
                                color="primary"
                                fill="clear"
                            >
                                {t('registration.phone.verification.BTN_RESEND_CODE')}
                            </IonButton>
                        }
                        <div> {t('registration.phone.verification.BTN_RESEND_CODE_IN')} {counter}s</div>


                    </div>

                    <IonGrid className="recovery_phone_keypad">

                        <KeyPad handleClick={handleClick} handleRemove={handleRemove} compact />

                    </IonGrid>

                </IonContent>

            </IonPage>
        </form>
    )
}

export default LoginPhoneVerifyPage

